import { render, staticRenderFns } from "./DashboardNum.vue?vue&type=template&id=131469f6&scoped=true"
import script from "./DashboardNum.vue?vue&type=script&lang=js"
export * from "./DashboardNum.vue?vue&type=script&lang=js"
import style0 from "./DashboardNum.vue?vue&type=style&index=0&id=131469f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131469f6",
  null
  
)

export default component.exports